import { format, addSeconds, differenceInMinutes } from 'date-fns'
import { SeItem, SeColumn } from './StyledElements.jsx'
import greenCheck from '../assets/green_checked.png'
import { sessionColors } from '../assets/colors.js'
import { checkDate } from '../assets/assets_functions.js'
import { useMobile } from '../utils/hooks.jsx'

const SessionItem = ({
  session,
  onClick,
  isGrey,
  isSelected,
  wA,
  restricted,
}) => {
  const { mobile } = useMobile()
  let temp_bg
  let temp_cl = sessionColors.itemText
  if (!isSelected && !isGrey) {
    temp_bg = sessionColors.itemNotSelectedNotGreyBg
  } else if (isSelected) {
    temp_bg = sessionColors.itemSelectedBg
    temp_cl = sessionColors.itemTextSelected
  } else temp_bg = sessionColors.itemNotSelectedGreyBg

  const startDate = checkDate(new Date(session.sessionStart))
  const endDate = checkDate(
    addSeconds(
      new Date(session.sessionStart),
      restricted ? session.restrictedSessionDuration : session.sessionDuration
    )
  )

  // const start_str = format(startDate, 'dd-MM-yyyy\xa0\xa0\xa0\xa0HH:mm', {
  //   timeZone: session.timeZone,
  // })
  const start_str = format(startDate, 'dd-MM-yyyy', {
    timeZone: session.timeZone,
  })

  const period = differenceInMinutes(endDate, startDate)
  const period_str = format(new Date(0, 0, 0, 0, period, 0, 0), 'HH:mm')

  let i = 0
  return (
    <>
      <SeItem id={session._id} onClick={onClick} bg={temp_bg} cl={temp_cl}>
        <SeColumn
          id={session._id}
          w={wA[i]}
          align={'left'}
          title={session.sessionTitle}
        >
          {session.sessionTitle}
        </SeColumn>
        <SeColumn
          id={session._id}
          w={wA[++i]}
          align={!mobile ? 'left' : 'center'}
        >
          {!mobile ? start_str + '\xa0\xa0\xa0\xa0' + period_str : start_str}
        </SeColumn>
        {/* <SeColumn id={session._id} w={wA[++i]} align={'center'}>
          {period_str}
        </SeColumn> */}
        {!mobile && (
          <SeColumn id={session._id} w={wA[++i]} align={'center'}>
            {session.meteoStationId && (
              <img src={greenCheck} style={{ width: '12px' }} alt="xx" />
            )}
          </SeColumn>
        )}
      </SeItem>
    </>
  )
}

export default SessionItem
